export const TopBarName = 'topBarComponent';
